import type React from "react";
import {YStack} from "@chayka/ui";
import {ProfileCard} from "../ProfileCard";
import {ChatbubblesOutline} from "@chayka/icons";
import {useAuth} from "@/hooks/useAuth";
import {SignInOrSignUp} from "../SignInOrSignUp";

const DrawerMenuItem: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({
  children,
  ...rest
}) => {
  return (
    <a {...rest} className="text-sm font-semibold text-inactive-text">
      {children}
    </a>
  );
};

export const DrawerMenuContent: React.FC<{onContactClick?: () => void}> = ({onContactClick}) => {
  const {isAuthenticated} = useAuth();

  const items = [
    {label: "Профиль", href: "/app/profile", authRequired: true},
    {
      label: "Правила студии",
      href: isAuthenticated ? "/app/rules" : "/guest/rules",
      authRequired: false,
    },
    {
      label: "Контакты студии",
      href: isAuthenticated ? "/app/contacts" : "/guest/contacts",
      authRequired: false,
    },
    {
      label: "График работы",
      href: isAuthenticated ? "/app/schedule" : "/guest/schedule",
      authRequired: false,
    },
  ];

  return (
    <YStack className="p-6 pb-12 justify-between h-full">
      <YStack className="gap-12">
        {isAuthenticated && <ProfileCard />}
        <YStack className="gap-6">
          {items.map((item) => {
            if (item.authRequired && !isAuthenticated) return null;
            return (
              <DrawerMenuItem key={item.href} href={item.href}>
                {item.label}
              </DrawerMenuItem>
            );
          })}
        </YStack>

        {!isAuthenticated && <SignInOrSignUp />}
      </YStack>

      <div onClick={onContactClick} className="text-secondary-text text-sm flex items-center gap-2">
        <ChatbubblesOutline size={18} />
        Проблемы с приложением?
      </div>
    </YStack>
  );
};
